import React from 'react';
import { generateClient } from 'aws-amplify/api';
import { createContactSubmission } from './graphql/mutations';
import './App.css';

const client = generateClient();

const COSTA_MESA_ZIPS = ['92626', '92627', '92628'];
const STORAGE_KEY = 'cmq_submission_times';
const MAX_SUBMISSIONS = 3;
const WINDOW_MS = 24 * 60 * 60 * 1000; // 24 hours

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zipCode: '',
      zipSubmitted: false,
      zipValid: false,
      name: '',
      email: '',
      phone: '',
      message: '',
      formSubmitted: false,
      rateLimited: false,
    };

    this.handleZipChange = this.handleZipChange.bind(this);
    this.handleZipSubmit = this.handleZipSubmit.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  getRecentSubmissionTimes() {
    let times = [];
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      times = raw ? JSON.parse(raw) : [];
    } catch (err) {
      times = [];
    }
    const cutoff = Date.now() - WINDOW_MS;
    return times.filter((t) => t > cutoff);
  }

  recordSubmission() {
    const recent = this.getRecentSubmissionTimes();
    recent.push(Date.now());
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(recent));
    } catch (err) {
      // localStorage unavailable (private browsing, etc.) — fail silently
    }
  }

  handleZipChange(e) {
    this.setState({ zipCode: e.target.value });
  }

  handleZipSubmit(e) {
    e.preventDefault();

    const recent = this.getRecentSubmissionTimes();
    if (recent.length >= MAX_SUBMISSIONS) {
      this.setState({ rateLimited: true, zipSubmitted: true });
      return;
    }

    const isValid = COSTA_MESA_ZIPS.includes(this.state.zipCode.trim());
    this.setState({
      zipSubmitted: true,
      zipValid: isValid,
    });
  }

  handleFormChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async handleFormSubmit(e) {
    e.preventDefault();

    const recent = this.getRecentSubmissionTimes();
    if (recent.length >= MAX_SUBMISSIONS) {
      this.setState({ rateLimited: true });
      return;
    }

    try {
      await client.graphql({
        query: createContactSubmission,
        variables: {
          input: {
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone,
            message: this.state.message,
            zipCode: this.state.zipCode,
          },
        },
      });
      this.recordSubmission();
      this.setState({ formSubmitted: true });
    } catch (err) {
      console.error('Error saving submission:', err);
    }
  }

  render() {
    const {
      zipCode,
      zipSubmitted,
      zipValid,
      name,
      email,
      phone,
      message,
      formSubmitted,
      rateLimited,
    } = this.state;

    if (rateLimited) {
      return (
        <div className="App">
          <header className="App-header">
            <h1>Costa Mesa Questions/Concerns</h1>
            <div className="form-card">
              <h2>Thanks for Your Interest</h2>
              <p>
                You've reached the limit of 3 submissions in a 24-hour
                period. Please check back tomorrow, or reach out directly at{' '}
                Steve@Steve4CostaMesa.com.
              </p>
            </div>
          </header>
        </div>
      );
    }

    return (
      <div className="App">
        <header className="App-header">
          <h1>Costa Mesa Questions/Concerns</h1>
          <p className="intro-text">
            Your voice matters. Help us understand what's really happening
            in your neighborhood. Whether it's traffic, safety,
            maintenance, noise, homelessness, or other community concerns,
            we want to hear from you. Your feedback helps city leaders
            identify issues, prioritize solutions, and improve the quality
            of life for all Costa Mesa Residents.
          </p>

          {!zipSubmitted && (
            <div className="form-card">
              <h2>Get Started</h2>
              <form onSubmit={this.handleZipSubmit}>
                <label>
                  What is your zip code?
                  <input
                    type="text"
                    value={zipCode}
                    onChange={this.handleZipChange}
                    pattern="[0-9]{5}"
                    maxLength="5"
                    placeholder="Costa Mesa Zip Code"
                    required
                  />
                </label>
                <button type="submit">Continue</button>
              </form>
            </div>
          )}

          {zipSubmitted && !zipValid && (
            <div className="form-card">
              <h2>Sorry</h2>
              <p>
                This form is only for Costa Mesa residents. If you believe
                this is an error, please double check your zip code.
              </p>
            </div>
          )}

          {zipSubmitted && zipValid && !formSubmitted && (
            <div className="form-card">
              <h2>Tell Us Your Concern</h2>
              <form onSubmit={this.handleFormSubmit}>
                <label>
                  Name
                  <input
                    name="name"
                    value={name}
                    onChange={this.handleFormChange}
                    placeholder="Your name"
                    required
                  />
                </label>

                <label>
                  Email
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={this.handleFormChange}
                    placeholder="you@example.com"
                    required
                  />
                </label>

                <label>
                  Phone (optional)
                  <input
                    name="phone"
                    value={phone}
                    onChange={this.handleFormChange}
                    placeholder="(555) 555-5555"
                  />
                </label>

                <label>
                  Your question or concern
                  <textarea
                    name="message"
                    value={message}
                    onChange={this.handleFormChange}
                    rows={5}
                    placeholder="What's on your mind?"
                    required
                  />
                </label>

                <button type="submit">Send</button>
              </form>
            </div>
          )}

          {formSubmitted && (
            <div className="form-card">
              <h2>Thank You</h2>
              <p>Thanks, {name} — your message has been received.</p>
            </div>
          )}
        </header>
      </div>
    );
  }
}

export default App;